import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('dock', {
  root: {
    states: ['disabled'],
  },
});
